var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-x-transition',{attrs:{"hide-on-leave":""}},[(_vm.visible)?_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-progress-circular',{class:{'mt-5': _vm.useMarginTop},attrs:{"size":_vm.size,"color":"primary","indeterminate":""}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }